import { initSlots } from '../../../../adapters/initWidgetData/initSlots/initSlots';
import { TriggeredByOptions } from '../../../../utils/bi/consts';
import { AsyncComponentDataStatus } from '../../state/types';
import { DailyAgendaActionFactory, DailyAgendaActions } from '../actions';

export const createOnTimeZoneChangeAction: DailyAgendaActionFactory<
  DailyAgendaActions['onTimeZoneChange']
> =
  ({ setState, flowAPI, getState, biLogger }) =>
  async (timeZoneId) => {
    setState({
      selectedTimezone: timeZoneId,
      slots: { status: AsyncComponentDataStatus.LOADING },
      slotsMetaData: { status: AsyncComponentDataStatus.LOADING },
    });
    await initSlots(
      { flowAPI, getState, setState, biLogger },
      TriggeredByOptions.TIMEZONE_CHANGED,
    );
  };
